import script from "./YoutubeTranscriptView.vue?vue&type=script&setup=true&lang=js"
export * from "./YoutubeTranscriptView.vue?vue&type=script&setup=true&lang=js"

import "./YoutubeTranscriptView.vue?vue&type=style&index=0&id=0938b60a&lang=scss"

const __exports__ = script;

export default __exports__